import { connectFela } from '../../dependencies';
import ZipCodeField from './ZipCodeField';
import * as styles from './ZipCodeField.styles';

export default connectFela(styles)(ZipCodeField);
